// Capture before Overview clears the wizard step. Async continuations must use
// these values, including the owning lead/treatment, rather than mutable Redux.
const immutableCopy = (value) => {
    if (value == null || typeof value !== 'object') return value;
    return Object.freeze(Array.isArray(value)
        ? value.map(immutableCopy)
        : Object.fromEntries(Object.entries(value).map(([key, item]) => [key, immutableCopy(item)])));
};

export function captureOverviewBookingCompletion({ practiceId, lead, treatmentId, detail, manualBooking, isScopeCurrent }) {
    const payment = detail?.payment;
    if (!manualBooking || !payment?.payment_type || payment.payment_type === 'No'
        || !['PHONE', 'INPRACTICE'].includes(payment.mode_of_payment)) return null;
    const treatment = lead?.lead_treatments?.find((row) => String(row.id) === String(treatmentId));
    if (!practiceId || !lead?.id || !treatment || (treatment.lead != null && String(treatment.lead) !== String(lead.id))) {
        throw new Error('Select the exact treatment and booking scope before completing.');
    }
    return Object.freeze({
        practiceId, leadId: lead.id, treatmentId: treatment.id, isScopeCurrent,
        appointment: immutableCopy({ ...detail.lead_appointment, lead: lead.id, lead_treatment: treatment.id }),
        treatment: immutableCopy({ ...detail.lead_treatment, lead: lead.id, id: treatment.id }),
        personalDetail: immutableCopy(detail.personalDetail),
        payment: immutableCopy(payment),
    });
}
